import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import WhatsNewsData from './Data';
import WhatsNewsView from './View';

const WhatsNewsEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <WhatsNewsView {...props} />
      <SidebarPortal selected={selected}>
        <WhatsNewsData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(WhatsNewsEdit);
